module.exports = __webpack_public_path__ + "static/img/static-zoom-county-0-core.78b07f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static-zoom-county-0-core.png
// module id = 70
// module chunks = 0